module.exports = function() {
  return new Worker(__webpack_public_path__ + "a56b999e19a7288b2d8f.worker.js");
};